import { render, staticRenderFns } from "./knowledgeList.vue?vue&type=template&id=6fb30198"
import script from "./knowledgeList.vue?vue&type=script&lang=js"
export * from "./knowledgeList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports